/** Who is typing, as shown by the typing bubble (from a realtime `typing` beat). */
export interface TypingActor {
  name: string;
  kind?: string;
  /** Operator's photo from the beat (`from.avatar`). AI/bot beats use the
   *  configured assistant avatar instead (handled in `BotAvatar`). */
  avatar?: string;
  /** AI turn phase (`"thinking"` / `"searching"` / `"typing"`) - drives the
   *  caption. Absent for operator typing. */
  phase?: string;
}

/**
 * State updater for a typing beat: keeps the CURRENT object when the beat says
 * nothing new. The server repeats the beat every ~4 s; a fresh object each time
 * re-rendered the tab for no visible change.
 */
export function nextTypingActor(next: TypingActor): (prev: TypingActor | null) => TypingActor {
  return (prev) =>
    prev &&
    prev.name === next.name &&
    prev.kind === next.kind &&
    prev.avatar === next.avatar &&
    prev.phase === next.phase
      ? prev
      : next;
}
